import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMSetupCityListResponse, IBOMSetupCityListResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useBOMSetupCityListAPI = () => {
  const [bomCityList, setBomCityList] = useState<IBOMSetupCityListResponseData[]>([]);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (cityIds: string[] = []) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        await axios
          .post(
            INVENTORY_MODULE?.BOM_SETUP_CITY_LIST_API?.baseURL,
            { city_list: cityIds },
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IBOMSetupCityListResponse>) => {
            if (res.data.status === true) {
              setBomCityList(res.data.data);
            } else {
              setBomCityList([]);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setBomCityList([]);
        captureError(error);
        if (axios.isAxiosError(error)) {
          //
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, bomCityList };
};
